import { render, staticRenderFns } from "./expertAnalysis.vue?vue&type=template&id=38f2c0bf&"
import script from "./expertAnalysis.vue?vue&type=script&lang=js&"
export * from "./expertAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports